<template >
    <router-link to="/" class="logo" :style="{...styles}">
        <img v-if="white" class="w-100 h-100" src="../../assets/logo-white.svg" alt="logo">
        <img v-else class="w-100 h-100" src="../../assets/logo-black.svg" alt="logo">
    </router-link>
</template>
<script>
export default {
    name: 'LogoComponent' ,
    props: ['styles', 'white']
}
</script>
<style scoped>
    .logo {
        all: unset;
        width: 150px;
        height: 80px;
        cursor: pointer;
        display: block;
    }
</style>